import { Component, EventEmitter, Output } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-account-header',
  imports: [TranslateModule],
  templateUrl: './account-header.html',
  styleUrl: './account-header.scss',
})
export class AccountHeader {
  @Output() readonly createRequested = new EventEmitter<void>();

  requestCreate(): void {
    this.createRequested.emit();
  }
}
